<template>
    <div class="mc-layout-row">
        <div :class="`mc-row-item ${alignColumn}`">
            <div class="mc-row-item-label" v-show="labelShow" :style="`width:${labelWidth}px; margin-right:${labelMarginRight}px;`">
                <i v-if="labelIconLeft" :class="labelIconLeft" style="margin: 0 5px;"></i>                
                {{labelText}}
                <i v-if="labelIconRight" :class="labelIconRight" style="margin: 0 5px;"></i>
                <strong v-if="important" style="color:red;margin: 0 5px;">*</strong>
            </div>
            <div :class="contentClass">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "mc-layout-row",
        data() {
            return {}
        },
        props: {
            important: {
                type: Boolean,
                default: false,
            },
            labelShow: {
                type: Boolean,
                default: true,
            },
            labelText: {
                type: String,
                default: ""
            },
            labelIconLeft: {
                type: String,
                default: "",
            },
            labelIconRight: {
                type: String,
                default: "",
            },
            labelWidth: {
                type: Number,
                default: 75
            },
            labelMarginRight: {
                type: Number,
                default: 20
            },
            contentAlignRow: {
                type: String,
                default: "center",
            },
            alignColumn: {
                type: String,
                default: "middle",
            },
        },
        computed: {
            contentClass: function(){
                let str = `mc-layout-row-content ${this.contentAlignRow} ${this.contentAlignColumn}`;
                return str;
            },
        },
    }
</script>

<style lang="less" scoped>
    .mc-layout-row {
        width: 100%;
        padding: 10px 0;
        .mc-row-item {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            &.top {
                align-items: flex-start;
            }
            &.middle {
                align-items: center;
            }
            &.bottom {
                align-items: flex-end;
            }
        }
        .mc-row-item-label {
            display: flex;
            align-items: center;
            height: 40px;
            padding: 0 20px;
            border: 1px solid #dcdfe6;
            color: #909399;
            background-color: #f5f7fa;
            border-radius: 4px;
        }
        .mc-layout-row-content {
            display: flex;
            align-items: center;
            width: 100%;
            height: 100%;
            &.left {
                justify-content: flex-start;
            }
            &.center {
                justify-content: center;
            }
            &.right {
                justify-content: flex-end;
            }
        }
    }
</style>